// extracted by mini-css-extract-plugin
module.exports = {"RightColumn":"AboutPage_RightColumn__103Ud","Portrait":"AboutPage_Portrait__1MkpE"};